import tou from "./assets/pdf/tou.pdf";

function ToU() {
  return (
    <div className="min-h-screen flex justify-center p-4">
      <object
        data={tou}
        type="application/pdf"
        className="min-h-screen"
        width="100%"
        height="100%"
      >
        <p>Terms of Use</p>
      </object>
    </div>
  );
}

export default ToU;
